import { render, staticRenderFns } from "./Order_customer_edit_lots.vue?vue&type=template&id=b8591f62&scoped=true&"
import script from "./Order_customer_edit_lots.vue?vue&type=script&lang=js&"
export * from "./Order_customer_edit_lots.vue?vue&type=script&lang=js&"
import style0 from "./Order_customer_edit_lots.vue?vue&type=style&index=0&id=b8591f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8591f62",
  null
  
)

export default component.exports